/**
 * Normalize the various list-shaped responses returned by the API:
 *  - `{ data: { docs: T[], pagination: ... } }`  (paginated wrapper)
 *  - `{ docs: T[] }`                              (paginated, no `data` envelope)
 *  - `{ data: T[] }`                              (flat list inside `data`)
 *  - `T[]`                                        (flat list, no envelope)
 *
 * Returns `[]` when the response is missing/loading/malformed so callers can
 * safely call `.filter`/`.map`/`.find` without runtime crashes.
 */
export function extractList<T = unknown>(payload: unknown): T[] {
  const d = payload as any;
  if (Array.isArray(d?.data?.docs)) return d.data.docs as T[];
  if (Array.isArray(d?.docs)) return d.docs as T[];
  if (Array.isArray(d?.data)) return d.data as T[];
  if (Array.isArray(d)) return d as T[];
  return [];
}
